import React from 'react';
import { MonthYear } from '../types';
import BaseScanHeader from './BaseScanHeader';

export type DateMonthScanHeaderOwnProps = {
    previousMonthYear: MonthYear;
    nextMonthYear: MonthYear;
    monthYearDisplay: string;
    onSwitchToYearScan: () => void;
    onMonthYearChange: (monthYear: MonthYear) => void;
};

export type DateMonthScanHeaderProps = DateMonthScanHeaderOwnProps;

const DateMonthScanHeader: React.FC<DateMonthScanHeaderProps> = (props) => {
    return (
        <BaseScanHeader
            display={props.monthYearDisplay}
            onPreviousPress={() => props.onMonthYearChange(props.previousMonthYear)}
            onNextPress={() => props.onMonthYearChange(props.nextMonthYear)}
            onDisplayPress={props.onSwitchToYearScan}
        />
    );
};

export default React.memo(DateMonthScanHeader);
